import { render, staticRenderFns } from "./submissionRequestDialog.vue?vue&type=template&id=b00426c4&"
import script from "./submissionRequestDialog.vue?vue&type=script&lang=js&"
export * from "./submissionRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports